const AddressFinder = (function () {
	const settings = {
		key: 'AE73-ED48-EP86-HN39',
		isMiddleware: false,
		origin: 'GB',
		countries: ['GB'],
		language: 'en-gb'
	};

	let thisForm;

	const init = function (form) {
		thisForm = form;
		listeners(form);
		countryListeners(form);
	};

	const countryListeners = function (form) {
		document.addEventListener('change', function (e) {
			if (e.target && e.target.classList.contains('js-country')) {
				// get ids to use in querySelector lookups
				const house_number_id = e.target.id.replace('countryID-', 'house-number-');
				const county_id = e.target.id.replace('countryID-', 'county-');

				if (e.target.value == 'GB') {
					document.querySelector(`#${house_number_id}`).classList.add('js-address-search');
				} else {
					document.querySelector(`#${house_number_id}`).classList.remove('js-address-search');
				}
				if (e.target.value == 'US') {

					document.querySelector(`select#${county_id}`).style.display = 'block';
					document.querySelector(`select#${county_id}`).setAttribute('required', '');

					document.querySelector(`input#${county_id}`).style.display = 'none';
					document.querySelector(`label[for=${county_id}]`).innerText = 'State *'
				} else {
					document.querySelector(`select#${county_id}`).style.display = 'none';
					document.querySelector(`select#${county_id}`).removeAttribute('required');
					document.querySelector(`input#${county_id}`).style.display = 'block';
					document.querySelector(`label[for=${county_id}]`).innerText = 'County / State'
				}
			}
		})
	}

	const listeners = function (form) {
		document.addEventListener('input', function (e) {
			e.preventDefault();
			if (e.target && e.target.classList.contains('js-address-search')) {
				find(e.target);
			}
		});
		document.addEventListener('click', function (e) {
			if (e.target && e.target.classList && !e.target.classList.contains('js-address-search')) {
				!!document.querySelectorAll('.address-finder__list').length && document.querySelector('.address-finder__list').remove();
			}
		})
	};

	const find = function (el, container = '') {
		let addressField = el;
		let addressText = addressField.value;

		if (addressText == '') {
			addressField.classList.add('form__error')
		} else {
			addressField.classList.remove('form__error')

			const url = 'https://api.addressy.com/Capture/Interactive/Find/v1.10/json3.ws';
			let params = '';
			params += "&Key=" + encodeURIComponent(settings.key);
			params += "&Text=" + encodeURIComponent(addressText);
			params += "&IsMiddleware=" + encodeURIComponent(settings.isMiddleware);
			params += "&Container=" + encodeURIComponent(container);
			params += "&Origin=" + encodeURIComponent(settings.origin);
			params += "&Countries=" + encodeURIComponent(settings.countries);
			params += "&Limit=" + encodeURIComponent('10');
			params += "&Language=" + encodeURIComponent(settings.language);
			const http = new XMLHttpRequest();
			http.open('POST', url, true);
			http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
			http.onreadystatechange = function () {
				if (http.readyState == 4 && http.status == 200) {
					let response = JSON.parse(http.responseText);
					// Test for an error
					if (response.Items.length == 1 && typeof (response.Items[0].Error) != "undefined") {
						// Show the error message
						alert(response.Items[0].Description);
					} else {
						// Check if there were any items found
						if (response.Items.length == 0) {
							alert("Sorry, there were no results");
						} else {
							showSelections(el, response);
						}
					}
				}
			}
			http.send(params);
		}
	};

	const showSelections = function (el, response) {
		let addressResultsContainer = el.parentNode.parentNode.parentNode.querySelector('.js-address-finder-results');

		let listEl = document.createElement("ul");
		listEl.classList.add("address-finder__list");
		response.Items.forEach(el => {
			let listItem = document.createElement("li");
			listItem.classList.add("address-finder__item");
			let link = document.createElement("a");
			link.setAttribute('href', '#');
			link.classList.add("address-finder__link");
			link.addEventListener('click', function (e) {
				e.preventDefault();
				if (el.Type == 'Address') {
					getAddress(addressResultsContainer, `${el.Id}`, `${el.Type}`);
				}
				return false;
			});
			let text = document.createTextNode(`${el.Text} ${el.Description}`);
			link.appendChild(text);
			listItem.appendChild(link);
			listEl.appendChild(listItem);
		});

		// add a manual entry link
		let listItem = document.createElement("li");
		listItem.classList.add("address-finder__item");
		let link = document.createElement("a");
		link.setAttribute('href', '#');
		link.classList.add("address-finder__link");
		link.addEventListener('click', function (e) {
			e.preventDefault();
			manualEntry(addressResultsContainer);
			return false;
		});
		let text = document.createTextNode(`Enter manually...`);
		link.appendChild(text);
		listItem.appendChild(link);
		listEl.appendChild(listItem);

		let oldEl = addressResultsContainer.querySelector('ul');
		if (oldEl) {
			oldEl.parentNode.removeChild(oldEl);
		}
		addressResultsContainer.insertBefore(listEl, null);
	};

	function manualEntry(addressListEl) {
		// remove list of addresses
		var oldEl = addressListEl.querySelector('ul');
		if (oldEl) {
			oldEl.parentNode.removeChild(oldEl);
		}

		// turn off address lookup
		let addressField = addressListEl.parentNode.querySelector('.js-address-search')
		addressField.classList.remove('js-address-search')
	}

	function getAddress(addressListEl, addressId, type = 'Address') {
		// remove list of addresses
		var oldEl = addressListEl.querySelector('ul');
		if (oldEl) {
			oldEl.parentNode.removeChild(oldEl);
		}

		// clear the search field
		addressListEl.parentNode.querySelector('.js-address-search').value = '';

		// find the address container id
		var addressContainer = addressListEl.previousElementSibling;

		var finderField = addressContainer.dataset.finderfield
		var addressFields = document.querySelector(`#addressFields-${finderField}`)

		// get the address fields to populate with data
		var houseNumField = addressFields.querySelector('.js-house-number');
		var street1Field = addressFields.querySelector('.js-street-1');
		var street2Field = addressFields.querySelector('.js-street-2');
		var cityField = addressFields.querySelector('.js-city');
		var countyField = addressFields.querySelector('.js-county');
		var postcodeField = addressFields.querySelector('.js-postcode');
		var countryField = addressFields.querySelector('.js-country');

		// do the lookup
		var url = 'https://api.addressy.com/Capture/Interactive/Retrieve/v1.00/json3.ws';
		var params = '';
		params += "&Key=" + encodeURIComponent(settings.key);
		params += "&Id=" + encodeURIComponent(addressId);

		if (type != 'Address') {
			params += "&Container" + encodeURIComponent(addressId);
		}

		var http = new XMLHttpRequest();
		http.open('POST', url, true);
		http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
		http.onreadystatechange = function () {
			if (http.readyState == 4 && http.status == 200) {
				var response = JSON.parse(http.responseText);
				// Test for an error
				if (response.Items.length == 1 && typeof (response.Items[0].Error) != "undefined") {
					// Show the error message
					alert(response.Items[0].Description);
				} else {
					// Check if there were any items found
					if (response.Items.length == 0) {
						alert("Sorry, there were no results");
					} else {
						var respAddress = response.Items[0];
						//console.log(respAddress);

						if (houseNumField) houseNumField.value = respAddress.Line1;
						if (street1Field) street1Field.value = respAddress.Line2;
						if (street2Field) street2Field.value = respAddress.Line3;
						if (cityField) cityField.value = respAddress.City;
						if (countyField) countyField.value = respAddress.ProvinceName;
						if (postcodeField) postcodeField.value = respAddress.PostalCode;

						if (countryField) {
							for (var i = 0; i < countryField.length; i++) {
								if (countryField[i].innerHTML == respAddress.CountryName || countryField[i].getAttribute('value') == respAddress.CountryIso2) {
									countryField[i].selected = true;
								}
							}
						}
					}
				}
			}
		}
		http.send(params);
	}


	return {
		init: init
	};
})();

export default AddressFinder;
